import { IS_IOS_DEVICE } from 'version-two/utils/constants';

const getIsIOSDevice = () => localStorage.getItem(IS_IOS_DEVICE) === 'true';

export default getIsIOSDevice;
